const isDevelopment = process.env.NODE_ENV === 'development'
const config = {
  backendUrl: !isDevelopment
    ? 'http://vestr-api-lb-1046244621.us-west-1.elb.amazonaws.com'
    : 'http://localhost:3001',
  socketUrl: !isDevelopment ? 'wss://vestr.io:3001' : 'ws://localhost:3001',
  LBbackendUrl: !isDevelopment
    ? 'http://vestr-api-lb-1046244621.us-west-1.elb.amazonaws.com'
    : 'http://localhost:3001',
  PortfolioBackendUrl: !isDevelopment
    ? 'http://vestr-api-lb-1046244621.us-west-1.elb.amazonaws.com'
    : 'http://localhost:3001',
}

export default config
